import App from "./App";
import './index.css';

new App();
